import { anmelden } from "./Login.js";
import { showPasswordForgotDialog } from "./PasswordDialoges.js";
import { loadSideNavigation } from './SideNavigation.js';
import { loadTopNavigation } from './TopNavigation.js';
import { bootStrap } from "./Translation.js";
import './UserForgotpasswordDialogComponent.js';

document.addEventListener('DOMContentLoaded', async () => {
    // BOOKMARK clear local and session storage
    window.localStorage.removeItem('userName');
    window.sessionStorage.removeItem('clientPraefix');
    window.localStorage.removeItem('userIsApplicationDeveloper');
    window.localStorage.removeItem('userIsApplicationAdmin');
    window.sessionStorage.removeItem('userGroups');

    const urlSearchParam = (new URL(document.location.toString())).searchParams;
    const language = urlSearchParam.get('l') ?? 'de-DE';
    const topNavigationId = (document.head.querySelector('meta[name="top-navigation-id"]') as HTMLMetaElement).content ?? 'home';
    const defaultSideNavigationId = (document.head.querySelector('meta[name="default-side-navigation-id"]') as HTMLMetaElement).content ?? 'login';
    const navIcon = '/images/fm_care_logo_silver_animated.svg';

    const forgotPasswordDiv = document.querySelector('.forgot-password') as HTMLDivElement;
    if (forgotPasswordDiv) { forgotPasswordDiv.addEventListener('click', forgotPassword); }
 
    await bootStrap(language);

    await loadTopNavigation(topNavigationId,
                            defaultSideNavigationId,
                            navIcon);

    await loadSideNavigation(topNavigationId,
                             defaultSideNavigationId,
                             '',
                             '');

    document.body.addEventListener('keypress', (e) => {
        if (e.which === 13) {
            e.stopImmediatePropagation();
            e.preventDefault();
            anmelden();
            return true;
        }
        return false;
    });

    document.querySelectorAll('input.login')?.forEach((inputField) => {
        inputField.addEventListener('click', (e: Event) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            (e.target as HTMLInputElement)?.select();
        });
    });

    document.querySelector('.g-dialog-container')?.addEventListener('closeDialog', (e: Event) => {
        e.stopImmediatePropagation();
        document.querySelector('.g-dialog-container > .g-dialog-container-image > div')?.remove();
        document.querySelector('.g-dialog-container')?.toggleAttribute('hidden', true);
    });

    document.querySelector('#id_a_anmelden')?.addEventListener('click', async () => await anmelden());
});

function forgotPassword(e: Event) {
    try {
        e.stopImmediatePropagation();
        e.preventDefault();

        const userNameInput = (document.querySelector('.login-username') as HTMLInputElement).value;

        showPasswordForgotDialog('g-dialog-container',
                                 userNameInput,
                                 false);

    } catch (err: unknown) {
        console.error(`${(err as Error).name} ${(err as Error).message} at: ${(err as Error).stack}`);
    }
}
